import { QPoint } from "../CoreApp/QPoint";

export function EventToCanvas(event, offsetLeft, offsetTop) {
  var p = new QPoint();
  p.x = event.clientX - offsetLeft;
  p.y = event.clientY - offsetTop;
  return p;
}
